export default __webpack_public_path__ + "static/media/contact-us-hero.bebe5066.png";